<template>
  <FontAwesomeIcon :icon="icon" />
</template>

<script setup>
import { computed } from 'vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import APP_ICONS from '@/app/data/app_icons.js';

const props = defineProps({
  name: { type: String, required: true },
});

const icon = computed(() => {
  const icon_fontawesome = APP_ICONS[props.name];
  if (icon_fontawesome) return icon_fontawesome;

  if (import.meta.env.IS_LOCAL) {
    throw new Error(`AppIcon: unknown icon name "${props.name}", add it to app_icons.js`);
  }
  return APP_ICONS['regular-circle-question'];
});
</script>
